import React from 'react'
import { t } from 'ttag'

import withRecharts from '../../../components/withRecharts'

const StudentBodySection = ({ demographics, recharts }) => {
  const { Cell, Legend, Pie, PieChart, ResponsiveContainer, Sector } = recharts

  if (!demographics) {
    return null
  }

  const cd = [
    {
      value: (demographics.totalWomen / demographics.total) * 100,
      name: t`Women`
    },
    {
      value: (demographics.totalMen / demographics.total) * 100,
      name: t`Men`
    }
  ]
  const cd2 = [
    {
      value: (demographics.hispanic / demographics.total) * 100,
      name: t`Hispanic / Latino`
    },
    {
      value: (demographics.unknown / demographics.total) * 100,
      name: t`Not Specified`
    },
    {
      value: (demographics.asian / demographics.total) * 100,
      name: t`Asian`
    },
    {
      value: (demographics.americanIndian / demographics.total) * 100,
      name: t`American Indian or Alaska Native`
    },
    {
      value: (demographics.white / demographics.total) * 100,
      name: t`White`
    },
    {
      value: (demographics.africanAmerican / demographics.total) * 100,
      name: t`Black or African American`
    },
    {
      value: (demographics.hawaiian / demographics.total) * 100,
      name: t`Native Hawaiian or other`
    },
    {
      value: (demographics.nonResident / demographics.total) * 100,
      name: t`Non-resident alien`
    },
    {
      value: (demographics.twoOrMore / demographics.total) * 100,
      name: t`Two or more races`
    }
  ]

  //console.log(cd2)

  const RADIAN = Math.PI / 180
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index
  }) => {
    if (percent == 0) {
      return null
    }

    const radius = innerRadius + (outerRadius - innerRadius) * 0.55
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central">
        {percent < 0.01 ? '< 1%' : `${(percent * 100).toFixed(0)}%`}
      </text>
    )
  }
  const renderShape = props => {
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value
    } = props

    //console.log(props)
    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={'#000000'}>
          {payload.percentageOfTotal}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    )
  }
  const renderLegend = props => {
    const { payload } = props

    //console.log(payload)
    return (
      <ul>
        {payload.map((entry, index) => (
          <li key={`item-${index}`}>
            <div
              style={{
                backgroundColor: entry.color,
                width: '15px',
                height: '15px',
                marginRight: '5px',
                display: 'inline-block'
              }}
              className="recharts-legend-icon">
            </div>
            {entry.value}:{' '}
            {entry.payload.value < 1 ? '< 1%' : `${entry.payload.value.toFixed(0)}%`}
          </li>
        ))}
      </ul>
    )
  }
  const demographicYear = '2020'

  return (
    <div className="section admissions-section sections">
      <h3>
        <span>{t`Student Body`}</span>
      </h3>
      <p>{t`In ${demographicYear}, for all enrolled students the student body was comprised of:`}</p>
      <ResponsiveContainer aspect={4 / 6} width="100%">
        <PieChart width={380} height={600} align="left" isAnimationActive={false}>
          <Pie
            data={cd}
            align="left"
            label={p => {
              return (
                <text {...p} fill="black">
                  {p.name}: {p.value < 1 ? '< 1%' : `${p.value.toFixed(0)}%`}
                </text>
              )
            }}
            innerRadius={80}
            cx="50%"
            cy="50%"
            outerRadius={100}
            labelLine={true}
            dataKey="value">
            {cd.map((e, index) => (
              <Cell
                key={`cell${index}`}
                fill={dynamicValues.plotColors[index % dynamicValues.plotColors.length]}
              />
            ))}
          </Pie>
          <Pie
            data={cd2}
            label={renderCustomizedLabel}
            labelLine={false}
            activeShape={renderShape}
            cx="50%"
            cy="50%"
            innerRadius={0}
            outerRadius={80}
            dataKey="value">
            {cd2.map((e, index) => (
              <Cell
                key={`cell2${index}`}
                fill={
                  dynamicValues.plotColors[(index + 2) % dynamicValues.plotColors.length]
                }
              />
            ))}
          </Pie>
          <Legend
            layout="vertical"
            width={0}
            content={renderLegend}
            //<path stroke="none" fill="#b3cc6c" d="M0,4h32v24h-32z" className="recharts-legend-icon"></path>
            height={300}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export default withRecharts(StudentBodySection)
